/** Formatting shared by the call room, the history list and voicemail. */

const pad = (value: number): string => String(value).padStart(2, '0');

/** `01:07` under an hour, `1:04:09` over it — a call is usually short. */
export function formatDuration(ms: number | null): string {
  if (ms === null || !Number.isFinite(ms) || ms <= 0) return '0:00';
  const total = Math.floor(ms / 1000);
  const seconds = total % 60;
  const minutes = Math.floor(total / 60) % 60;
  const hours = Math.floor(total / 3600);
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
}

const TODAY = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
const OLDER = new Intl.DateTimeFormat(undefined, {
  month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
});

/** Time for today, date + time for anything older. */
export function formatCallTime(iso: string | null): string {
  if (iso === null) return '—';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '—';
  const sameDay = new Date().toDateString() === at.toDateString();
  return sameDay ? TODAY.format(at) : OLDER.format(at);
}
